import React from "react";
import { Link } from "react-router-dom";

export default function HeaderDesktopNav({
  menus,
  desktopMenuOpenKey,
  setDesktopMenuOpenKey,
  isPrimaryMenuActive,
  isRouteActive,
}) {
  return (
    <div className="header-main-center d-none d-lg-flex align-items-center ms-3">
      <nav
        className="header-main-nav d-flex align-items-center gap-1 flex-nowrap text-nowrap"
        aria-label="주요 메뉴"
        onMouseLeave={() => setDesktopMenuOpenKey("")}
      >
        {menus.map((menu) => {
          const submenuItems = Array.isArray(menu.submenu) ? menu.submenu : [];
          const hasSubmenu = submenuItems.length > 0;

          return (
            <div
              className={`header-main-nav-item position-relative ${hasSubmenu && desktopMenuOpenKey === menu.key ? "show" : ""}`}
              key={menu.key}
              onMouseEnter={() => {
                if (hasSubmenu) {
                  setDesktopMenuOpenKey(menu.key);
                  return;
                }
                setDesktopMenuOpenKey("");
              }}
            >
              <Link
                to={menu.link}
                className={`header-main-nav-link ${isPrimaryMenuActive(menu) ? "active" : ""}`}
                onClick={(event) => {
                  setDesktopMenuOpenKey("");
                  event.currentTarget.blur();
                }}
              >
                {menu.label}
                {hasSubmenu && <i className="ri-arrow-down-s-line header-main-nav-caret"></i>}
              </Link>
              {hasSubmenu && (
                <div className="header-main-nav-submenu">
                  {submenuItems.map((submenu) => (
                    <Link
                      key={`${menu.key}-${submenu.link}`}
                      to={submenu.link}
                      className={`header-main-nav-submenu-link ${isRouteActive(submenu.link) ? "active" : ""}`}
                      onClick={(event) => {
                        setDesktopMenuOpenKey("");
                        event.currentTarget.blur();
                      }}
                    >
                      {submenu.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </nav>
    </div>
  );
}
